import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import AdminLayout from "../../../layout/AdminLayout";
import { theme } from "../../../theme/theme";
import { CustomBtn } from "../../../components/Common/CustomBtn";
import CreateDocumentModal from "../../../components/Modals/CreateDocumentModal";
import DocumentViewerModal from "../../../components/Common/DocumentViewerModal";
import DocumentFilePreview from "../../../components/Common/DocumentFilePreview";
import {
  ConfirmationSnackbar,
  ErrorSnackbar,
} from "../../../components/Common/CustomSnackbar";
import { getAllDocuments } from "../../../redux/dispatchers/documents.dispatcher";
import axiosInstance from "../../../utils/config/config";

const AdminDocuments = () => {
  const dispatch = useDispatch();
  const { allDocuments } = useSelector((state) => state.documents);

  const [createDocumentModal, setCreateDocumentModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [success, setSuccess] = useState(false);
  const [errorState, setErrorState] = useState({ error: false, errorMsg: "" });

  useEffect(() => {
    dispatch(getAllDocuments());
  }, [dispatch]);

  const handleDelete = async () => {
    try {
      await axiosInstance.delete(
        `/document/deleteDocument/${selectedDocument.id}`
      );
      setSelectedDocument(null);
      dispatch(getAllDocuments());
    } catch (error) {
      setErrorState({
        error: true,
        errorMsg: error?.response?.data?.message || "Failed to delete document",
      });
    }
  };

  const documents = allDocuments || [];

  return (
    <AdminLayout
      heading="Documents"
      actionButton={
        <CustomBtn
          text="Add Document"
          icon
          width="180px"
          height="45px"
          fontSize="16px"
          onClick={() => setCreateDocumentModal(true)}
        />
      }
    >
      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => setErrorState({ error: false, errorMsg: "" })}
        errorMsg={errorState.errorMsg}
      />
      <ConfirmationSnackbar
        snackbarState={success}
        handleSnackbarClose={() => setSuccess(false)}
        text="Document Added Successfully"
      />

      {documents.length === 0 ? (
        <Typography
          sx={{
            color: "rgba(255,255,255,0.6)",
            fontFamily: "Mulish-Regular",
            fontSize: "14px",
          }}
        >
          No documents available.
        </Typography>
      ) : (
        <Grid container spacing={2}>
          {documents.map((doc) => (
            <Grid item size={{ xs: 12, sm: 6, md: 3 }} key={doc.id}>
              <Box
                onClick={() => setSelectedDocument(doc)}
                sx={{
                  borderRadius: "14px",
                  overflow: "hidden",
                  border: theme.lightBorder,
                  backgroundColor: "rgba(255,255,255,0.03)",
                  cursor: "pointer",
                }}
              >
                {doc.cover_url ? (
                  <Box
                    component="img"
                    src={doc.cover_url}
                    alt={doc.title}
                    sx={{
                      width: "100%",
                      height: "140px",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                ) : (
                  <DocumentFilePreview fileName={doc.file_name} height="140px" />
                )}
                <Box sx={{ p: 2 }}>
                  <Typography
                    sx={{
                      color: "#fff",
                      fontFamily: "Mulish-SemiBold",
                      fontSize: "15px",
                      mb: 0.5,
                    }}
                  >
                    {doc.title}
                  </Typography>
                  <Typography
                    sx={{
                      color: "rgba(255,255,255,0.6)",
                      fontFamily: "Mulish-Regular",
                      fontSize: "12px",
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {doc.description}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      )}

      <CreateDocumentModal
        open={createDocumentModal}
        onClose={() => setCreateDocumentModal(false)}
        onCreated={() => {
          setSuccess(true);
          dispatch(getAllDocuments());
        }}
        setErrorState={setErrorState}
      />

      <DocumentViewerModal
        open={Boolean(selectedDocument)}
        onClose={() => setSelectedDocument(null)}
        document={selectedDocument}
        onDelete={handleDelete}
      />
    </AdminLayout>
  );
};

export default AdminDocuments;
